import $api from "@/frontend/shared/api/axios";

export async function deleteFile({ id, fileId }: { id: number; fileId: number }) {
  await $api.delete(`/portfolio-companies/${id}/data-room/${fileId}`);
}
